import { ImprovementPlanProcess, ProcessAchievement } from '../../models';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ValidateService } from '../../../../../../@core/utils/validate.service';
import { ISubscription } from 'rxjs/Subscription';
import { ApiClientService } from '../../../../../../@core/services';
import { FileVm } from '../../../../Models/fileVm';

@Component({
  selector: 'process-achievement-form',
  templateUrl: './process-achievement-form.component.html',
  styleUrls: ['./process-achievement-form.component.scss'],
  providers: [ValidateService],
})
export class ProcessAchievementFormComponent implements OnInit, OnDestroy {
  @Input() process: ImprovementPlanProcess;
  private subscription: ISubscription;
  valid: boolean;
  editMode: boolean = true;
  showErrors: boolean = false;
  constructor(private validationService: ValidateService, private api: ApiClientService) {}

  ngOnInit() {
    if (this.process.processAchievement && this.process.processAchievement.id) {
      this.editMode = false;
    } else {
      this.process.processAchievement = {} as ProcessAchievement;

      this.initValidation();
    }
  }
  initValidation() {
    if (this.process.evaluationMethods && Array.isArray(this.process.evaluationMethods)) {
      for (let i = 0; i < this.process.evaluationMethods.length; i++) {
        this.validationService.addInputKey('inputFile-' + i);
      }
    }

    this.validationService.registerForm([
      'proccessTarget',
      'targetedCalculationMechanism',
      'actualPerformance',
      'gapJustification',
      'imporvementPriorities',
    ]);
    this.subscription = this.validationService.validStatus.subscribe(status => {
      this.valid = status;
    });
  }
  isInputValid(name: string, status: boolean) {
    this.validationService.updateFormFlag(name, status);
  }

  ngOnDestroy() {
    if (this.editMode) this.subscription.unsubscribe();
  }
  // fileChange(index: number, event: FileVm[]) {
  //   this.process.evaluationMethods[index].file = event && event.length > 0 ? event[0] : {} as any;
  // }

  submitAchievement() {
    if (this.valid) {
      this.api.update('api/ImprovementPlan/Process', this.process).subscribe((res: number) => {
        // console.log('res', res);
        this.process.processAchievement.id = res;
        this.ngOnInit();
      });
    } else this.showErrors = true;
  }
  updatePriorities(event: { id: number; value: string }[]) {
    if (Array.isArray(event) && event.length > 0) {
      this.process.processAchievement.improvementPriorities = event.map((element: { id: number; value: string }) => {
        return { id: element.id, text: element.value };
      });
    }
  }
  preparePriorities() {
    if (
      Array.isArray(this.process.processAchievement.improvementPriorities) &&
      this.process.processAchievement.improvementPriorities.length > 0
    ) {
      return this.process.processAchievement.improvementPriorities.map((element: { id: number; text: string }) => {
        return { id: element.id, value: element.text };
      });
    } else return [];
  }
}
